import { render, staticRenderFns } from "./AccessoryItem.vue?vue&type=template&id=5dfa6495&"
import script from "./AccessoryItem.vue?vue&type=script&lang=ts&"
export * from "./AccessoryItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports